import React, { useState } from "react";
import {
  Card,
  Input,
  Button,
  Typography,
  Col,
  Avatar,
  Tooltip,
  message,
} from "antd";
import { css } from "@emotion/css";
import SendIcon from "../../../../Icons/SendIcon";
import { useSelector } from "react-redux";
import { CheckSquareOutlined, CopyOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ReferMaxCard = () => {
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  const [copied, setCopied] = useState(false);
  let companyId = "";
  let modules = [];
  if (sharedUserInfo?.payload?.company?.modules) {
    modules =
      sharedUserInfo.payload.company.modules.length > 0
        ? sharedUserInfo.payload.company.modules
        : [];
    companyId = sharedUserInfo?.payload?.company?.companyName;
  } else if (sharedUserInfo?.empCompanies?.[0]?.companyId?.modules) {
    modules =
      sharedUserInfo.empCompanies[0].companyId.modules.length > 0
        ? sharedUserInfo.empCompanies[0].companyId.modules
        : [];
    companyId = sharedUserInfo?.empCompanies[0]?.companyId?.companyName;
  }
  if (companyId) {
    companyId = companyId.replaceAll(" ", "%20");
  }
  const inviteLink = `${process.env.REACT_APP_FE_HR_URL}/user/invite/register?companyName=${companyId}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink);
    setCopied(true);
    message.success("Invite link copied!");
  };
  return (
    <Col span={24}>
      <Card
        title={`Refer MaxHR to your network today!`}
        className={css`
          width: 100%;
          max-width: 480px;
          height: 334px;
        `}
      >
        <div
          className={css`
            display: flex;
            flex-direction: column;
            gap: 16px;
          `}
        >
          {/* Header */}
          <div
            className={css`
              display: flex;
              justify-content: space-between;
              align-items: center;
            `}
          ></div>

          {/* Send Invitation Section */}
          <div
            className={css`
              display: flex;
              flex-direction: column;
              gap: 10px;
            `}
          >
            <Text
              className={css`
                // color: white;
                font-size: 16px;
                // color: #c8c3ce !important;
              `}
            >
              Send invitation Link
            </Text>
            <div
              className={css`
                display: flex;
                align-items: center;
                gap: 10px;
              `}
            >
              <Input
                value={inviteLink}
                readOnly
                className={css`
                  color: white;
                  padding: 12px 16px;
                  // border-radius: 8px;
                  flex: 1;
                  height: 48px !important;
                  // &::placeholder {
                  //   color: rgba(255, 255, 255, 0.45);
                  // }
                `}
                addonAfter={
                  <Tooltip title="Copy Invite Link">
                    {copied ? (
                      <CheckSquareOutlined style={{ fontSize: "16px" }} />
                    ) : (
                      <CopyOutlined
                        onClick={handleCopy}
                        style={{ cursor: "pointer", fontSize: "16px" }}
                      />
                    )}
                  </Tooltip>
                }
              />

              {/* <Button
                size="large"
                type="primary"
                icon={<SendIcon />}
                className={css`
                  width: 48px !important;
                  height: 48px !important;
                  min-width: 48px;
                  min-height: 48px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                `}
              /> */}
            </div>
          </div>

          {/* Social Media Section */}
          <div
            className={css`
              display: flex;
              flex-direction: column;
              gap: 10px;
            `}
          >
            <Text
              className={css`
                // color: white;
                font-size: 16px;
                padding-top: 24px;
                padding-bottom: 16px;
                // color: #c8c3ce !important;
              `}
            >
              Share on social media
            </Text>
            <div
              className={css`
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                align-items: center;
              `}
            >
              {[
                {
                  src: "/socialsLogo/img4.png",
                  alt: "WhatsApp",
                  href: "https://wa.me/971585669844",
                },
                {
                  src: "/socialsLogo/img1.png",
                  alt: "Facebook",
                  href: "https://www.facebook.com/maxerpai",
                },
                {
                  src: "/socialsLogo/img2.png",
                  alt: "Instagram",
                  href: "https://instagram.com/maxerp.ai",
                },
                {
                  src: "/socialsLogo/img5.png",
                  alt: "X.com",
                  href: "https://x.com/MaxERP_ai",
                },
                {
                  src: "/socialsLogo/img3.png",
                  alt: "LinkedIn",
                  href: "https://www.linkedin.com/company/maxerp-ai/",
                },
              ].map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css`
                    display: inline-block;
                  `}
                >
                  <Avatar
                    src={item.src}
                    alt={item.alt}
                    shape="square"
                    size={40}
                    className={css`
                      cursor: pointer;
                      min-width: 32px;
                      min-height: 32px;
                      max-width: 48px;
                      max-height: 48px;
                    `}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default ReferMaxCard;
